<template>
  <div class="main">
    <tab title="充值流水"></tab>
    <div class="record_box">
        <div class="record_oli" v-for="item in list" v-bind:key="item.id">
          <div class="oli_left">
            <img src="../../static/img/topup.png" alt="" />
          </div>
          <div class="right_box">
            <div class="oli_right" style="display: block;width: 100%;">
              {{ item.createTime }}
            </div>
            <div class="oli_right">
              <span class="lv">{{ item.chargeAmount }}元</span>
            </div>
            <div class="oli_right">
              <span class="lv">{{item.chargeType==0?'充值':'撤销'}}后{{ item.afterAmount }}元</span>
            </div>
          </div>
          
        </div>
        <!-- <div class="record_oli">
              <div class="oli_left">
                  <img src="/static/img/topup.png" alt="">
                  
              </div>
              <div class="oli_right">
               2021-11-05 15:59:00
              </div>
              <div class="oli_right">
                <span class="lv">5000.00元</span>
              </div>
          </div> -->

          
          
      </div>
    <scroller :onBottom="loadmore"></scroller>
  </div>
</template>

<script>
import tab from "@/components/NavBar";
import scroller from "@/components/scroller";
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

export default {
  name: "margin",
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 6,
      flag:true
    };
  },
  components: {
    tab,
    scroller,
  },
  mounted() {
    var height = (document.body.clientHeight-46)/68
    this.pageSize = Math.ceil(height)
    this.getChargeList();
  },
  methods: {
    getChargeList() {
        Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      var data = {
        token: this.$storage.get("token"),
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$api.post("orgapp/getChargeList", data, (response) => {
        console.log(response.data);
        if (response.status >= 200 && response.status < 300) {
            Toast.clear();
          var data = response.data;
          if (data.msg == "success") {
            var list = data.list;
            list.forEach((element) => {
              element.chargeAmount = (element.chargeAmount / 100).toFixed(2);
              element.afterAmount = (element.afterAmount / 100).toFixed(2);
            });
            if(list.length<this.pageSize){
                this.flag = false
            }
            if(this.page==1){
                this.list = list;
            }else{
                this.list = this.list.concat(list);
            }
            
          }
        }else{
            Toast.clear();
            Toast.fail(response.status);
        }
      });
    },
    loadmore() {
      console.log("触底了");
      if(this.flag){
        this.page++
        this.getChargeList()
      }else{
          Toast('没有更多内容了~');
      }
      
    },
  },
};
</script>

<style scoped>
/* .infinite {
  font-size: 0.32rem;
  line-height: 0.8rem;
  overflow: auto;
}
.infinite i {
  font-size: 0.24rem;
  text-align: center;
  width: 100%;
  display: block;
} */
.main {
  background-color: #f7f8fa;
  min-height: 100vh;
}
.record_box {
  width: 85%;
  margin: auto;
  margin-top: 20px;
}
.record_oli {
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  border-radius: 5px;
  color: #000;
  /* display: flex; */
  margin-bottom: 8px;
}
.right_box  {
  width: 76%;
  height: 100%;
  float: right;
}
.oli_left {
  height: 100%;
  margin-left: 10px;
  width: 19%;
  float: left;
}
.oli_left span {
  vertical-align: middle;
}
.oli_left img {
  width: 60px;
  height: 100%;
}
.oli_right {
  height: 30px;
  line-height: 30px;
  margin-left: 15px;
  display: inline-block;
  vertical-align: top;
}
.lv {
  color: #07c160;
}

.oli_after {
  /* display: block; */
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/top_up.vue